import { ISetPasswordRequest, IUpdateProfileRequest } from "./types";
import { baseProfileApi } from '@src/core/features';

export const profileApi = baseProfileApi.injectEndpoints({
  endpoints: (builder) => ({
    updateProfile: builder.mutation<void, IUpdateProfileRequest>({
      query: (data) => ({
        url: '/api/v1/user/profile',
        method: 'PUT',
        data,
      }),
      invalidatesTags: ['Profile'],
    }),
    setUserPassword: builder.mutation<void, ISetPasswordRequest>({
      query: (data) => ({
        url: '/api/v1/user/password',
        method: 'POST',
        data,
      })
    }),
    updateHub: builder.mutation({
      query: (data) => ({
        url: '/api/v1/organizations/hubs',
        method: 'PUT',
        data,
      }),
      invalidatesTags: ['Profile'],
    })
  })
});

export const { 
  useUpdateHubMutation,
  useUpdateProfileMutation,
  useSetUserPasswordMutation 
} = profileApi;